import React, { useEffect, useState } from "react";
import "./Styles/InterestForm.scss";
import { Checkbox, TextField } from "@mui/material";
import logo from "./Images/logo.svg";
import { useEnv } from "../context/env.context";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";

export const OpenInterestForm = () => {
  const { apiServerUrl } = useEnv();
  const [submitted, setSubmitted] = useState(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const typeParam = params.get("type");
  const [form, setForm] = useState({
    email: "",
    name: "",
    firstChoice: "",
    secondChoice: "",
    timezone: "",
    questions: "",
    choices: [],
    commitments: {
      showUp: false,
      ownership: false,
      helping: false,
      confidential: false,
    },
    type: typeParam || "normal",
    managerEmail: "",
    managerName: "",
  });

  const [endedModalShown, setEndedModalShown] = useState(true);

  useEffect(() => {
    const nav = document.getElementsByClassName("nav-bar__container")[0];
    if (nav) {
      nav.style = "display:none";
    }

    const container = document.getElementsByClassName("content_container")[0];
    if (container) {
      container.style = "max-width: 100%;width:100%;";
    }

    return () => {
      const nav = document.getElementsByClassName("nav-bar__container")[0];
      if (nav) {
        nav.style = "display:flex";
      }

      const container = document.getElementsByClassName("content_container")[0];
      if (container) {
        container.style = "max-width: 100%;width:100%;";
      }
    };
  }, []);

  const saveInterest = async () => {
    try {
      if (
        !form.commitments.showUp ||
        !form.commitments.ownership ||
        !form.commitments.helping ||
        !form.commitments.confidential
      ) {
        alert("Please agree to all the commitments");
        return;
      }

      if (
        !form.name ||
        !form.email ||
        !form.startDate ||
        !form.choices.length ||
        !form.timezone ||
        (typeParam !== "intern" && (!form.managerEmail || !form.managerName))
      ) {
        alert("Please fill out all fields");
        return;
      }

      const response = await fetch(`${apiServerUrl}/api/interest`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });
      const data = await response.json();
      setSubmitted(true);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="InterestForm">
      <div className="background">
        <img className="logo" src={logo} alt="logo" />
        {typeParam === "intern" && (
          <Chip
            className="program-chip"
            label="Intern Program"
            variant="outlined"
          />
        )}

        {!submitted && (
          <div className="form-input">
            <h3>Lennar's First-90-Day Program</h3>
            <p>
              Lennar cares about setting you up for success in your new role.
              That's why they've partnered with Crew to offer an amazing
              resource to new Associates: a small-group coaching program
              designed to help you make the most of your first 90 days. You'll
              get:
            </p>
            <ul>
              <li>
                A <b>support network</b> of your peers as you navigate your
                first months
              </li>
              <li>
                <b>Content</b> designed to help you bring your best self to your
                new role
              </li>
              <li>
                <b>Coaching</b> and support from a professional coach
              </li>
            </ul>
            <p>To reserve your place, fill out the short form below.</p>

            <div>
              <label htmlFor="name">Name</label>
              <TextField
                onChange={(e) => {
                  setForm({ ...form, name: e.target.value });
                }}
                type="text"
                id="name"
                variant="outlined"
              />
            </div>
            <div>
              <label htmlFor="email">Work Email</label>
              <TextField
                onChange={(e) => {
                  setForm({ ...form, email: e.target.value });
                }}
                type="email"
                variant="outlined"
                id="email"
              />
            </div>
            {typeParam !== "intern" && (
              <>
                <div>
                  <label htmlFor="manger-name">Manager Name</label>
                  <TextField
                    onChange={(e) => {
                      setForm({ ...form, managerName: e.target.value });
                    }}
                    type="text"
                    id="manager-name"
                    variant="outlined"
                  />
                </div>
                <div>
                  <label htmlFor="manger-email">Manager Email</label>
                  <TextField
                    onChange={(e) => {
                      setForm({ ...form, managerEmail: e.target.value });
                    }}
                    type="email"
                    variant="outlined"
                    id="manager-email"
                  />
                </div>
              </>
            )}
            <div>
              <label htmlFor="startDate">Lennar Start Date</label>
              <DatePicker
                dateFormat="P"
                selected={form.startDate}
                onChange={(e) => {
                  setForm({ ...form, startDate: e });
                }}
              />
            </div>
            <div>
              <h4>Preferred Timing</h4>
              <p>
                Crews are scheduled based on the timing that works best for the
                majority of new Associates. Please fill out your availability to
                the best of your knowledge below.
              </p>
              <p>
                Note: We know that as a new hire you may not have 100%
                visibility to your future schedule. If your availability
                changes, we'll do our best to assign you to another crew.
                Otherwise, you'll be able to opt-out of the program.
              </p>
              <label htmlFor="email">
                What Time Slots Work For You? (Check all that apply)
              </label>

              <div className="radio">
                <Checkbox
                  onChange={(e) => {
                    const newChoices = form.choices;
                    if (e.target.checked) {
                      newChoices.push("Wednesdays 10am EST");
                    } else {
                      const index = newChoices.indexOf("Wednesdays 10am EST");
                      if (index > -1) {
                        newChoices.splice(index, 1);
                      }
                    }
                    setForm({
                      ...form,
                      choices: newChoices,
                    });
                  }}
                />
                <p>Wednesdays 10am EST - 12pm EST</p>
              </div>

              <div className="radio">
                <Checkbox
                  onChange={(e) => {
                    const newChoices = form.choices;
                    if (e.target.checked) {
                      newChoices.push("Wednesdays 3pm EST");
                    } else {
                      const index = newChoices.indexOf("Wednesdays 3pm EST");
                      if (index > -1) {
                        newChoices.splice(index, 1);
                      }
                    }
                    setForm({
                      ...form,
                      choices: newChoices,
                    });
                  }}
                />
                <p>Wednesdays 3pm EST - 5pm EST</p>
              </div>

              <div className="radio">
                <Checkbox
                  onChange={(e) => {
                    const newChoices = form.choices;
                    if (e.target.checked) {
                      newChoices.push("Thursdays 10am EST");
                    } else {
                      const index = newChoices.indexOf("Thursdays 10am EST");
                      if (index > -1) {
                        newChoices.splice(index, 1);
                      }
                    }
                    setForm({
                      ...form,
                      choices: newChoices,
                    });
                  }}
                />
                <p>Thursdays 10am EST - 12pm EST</p>
              </div>

              <div className="radio">
                <Checkbox
                  onChange={(e) => {
                    const newChoices = form.choices;
                    if (e.target.checked) {
                      newChoices.push("Thursdays 3pm EST");
                    } else {
                      const index = newChoices.indexOf("Thursdays 3pm EST");
                      if (index > -1) {
                        newChoices.splice(index, 1);
                      }
                    }
                    setForm({
                      ...form,
                      choices: newChoices,
                    });
                  }}
                />
                <p>Thursdays 3pm EST - 5pm EST</p>
              </div>

              <div className="radio">
                <Checkbox
                  onChange={(e) => {
                    const newChoices = form.choices;
                    if (e.target.checked) {
                      newChoices.push("Fridays 10am EST");
                    } else {
                      const index = newChoices.indexOf("Fridays 10am EST");
                      if (index > -1) {
                        newChoices.splice(index, 1);
                      }
                    }
                    setForm({
                      ...form,
                      choices: newChoices,
                    });
                  }}
                />
                <p>Fridays 10am EST - 12pm EST</p>
              </div>
            </div>
            <div>
              <label htmlFor="email">What time zone are you in?</label>
              <select
                onChange={(e) => {
                  setForm({ ...form, timezone: e.target.value });
                }}
              >
                <option selected disabled>
                  Select an option
                </option>
                <option value="eastern">Eastern</option>
                <option value="central">Central</option>
                <option value="mountain">Mountain</option>
                <option value="pacific">Pacific</option>
                <option value="alaska">Alaska</option>
                <option value="hawaii">Hawaii</option>
              </select>
            </div>
            <h4>Crew Commitments</h4>
            <p>
              We ask Crew participants to agree to a few commitments before
              starting their Crew journey.
            </p>
            <div>
              <label htmlFor="email">Can you commit to the following?</label>
              <div className="radios">
                <div className="radio">
                  <Checkbox
                    onChange={(e) => {
                      setForm({
                        ...form,
                        commitments: {
                          ...form.commitments,
                          showUp: e.target.checked,
                        },
                      });
                    }}
                  />{" "}
                  <p>
                    I commit to showing up, for myself and for my "crew." That
                    means making every effort to show up on time and on video to
                    our calls.
                  </p>
                </div>
                <div className="radio">
                  <Checkbox
                    onChange={(e) => {
                      setForm({
                        ...form,
                        commitments: {
                          ...form.commitments,
                          ownership: e.target.checked,
                        },
                      });
                    }}
                  />{" "}
                  <p>
                    I commit to taking ownership. That means coming prepared to
                    your session with your pre-work complete (it only takes 30
                    minutes and is super fun!).
                  </p>
                </div>
                <div className="radio">
                  <Checkbox
                    onChange={(e) => {
                      setForm({
                        ...form,
                        commitments: {
                          ...form.commitments,
                          helping: e.target.checked,
                        },
                      });
                    }}
                  />{" "}
                  <p>
                    I commit to helping others succeed. That means actively
                    listening and contributing to the group discussion.
                  </p>
                </div>
                <div className="radio">
                  <Checkbox
                    onChange={(e) => {
                      setForm({
                        ...form,
                        commitments: {
                          ...form.commitments,
                          confidential: e.target.checked,
                        },
                      });
                    }}
                  />{" "}
                  <p>
                    I commit to keeping it confidential. That means keeping
                    information shared by my colleagues in Crew sessions
                    private.
                  </p>
                </div>
              </div>
            </div>

            <div>
              <p>
                If you have any questions please feel to reach out to the Crew
                team at{" "}
                <a href="mailto:hello@joinacrew.com">hello@joinacrew.com</a>.
              </p>
            </div>
            <button
              onClick={() => {
                saveInterest();
              }}
              className="btn primary"
            >
              Submit
            </button>
          </div>
        )}

        {submitted && (
          <div className="submitted">
            <h3>Thank you for your interest!</h3>
            <p>
              We'll be in touch soon with more details about your Crew journey.
            </p>
          </div>
        )}
      </div>
      <svg
        className="bottomLeft"
        xmlns="http://www.w3.org/2000/svg"
        width="234"
        height="141"
        viewBox="0 0 234 141"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M-20.937 158.029C-21.0212 158.118 -21.1685 158.208 -21.3553 158.322C-21.6788 158.519 -22.1208 158.789 -22.5582 159.248C-32.2356 149.106 -41.913 138.965 -51.1248 128.576C-55.1484 123.912 -58.8104 118.995 -62.4577 114.097C-63.8683 112.202 -65.2768 110.311 -66.7032 108.438C-67.1916 107.742 -67.7964 107.108 -68.4013 106.475C-69.0061 105.841 -69.611 105.207 -70.0994 104.511C-73.0527 99.3951 -76.0061 94.2787 -78.2582 88.9097C-80.2574 84.2419 -82.0268 79.3328 -81.9222 73.9067C-81.9632 72.212 -82.4045 70.6278 -82.8545 69.0128C-83.0929 68.1573 -83.3336 67.2933 -83.5185 66.3996C-83.8054 64.2843 -82.8856 63.3188 -80.9889 63.7446C-81.9257 59.2168 -78.6351 56.9454 -75.7795 54.9742L-75.7791 54.9739C-75.3793 54.6979 -74.988 54.4279 -74.6181 54.1583C-74.214 53.8746 -73.8313 53.5317 -73.4397 53.1809C-72.4831 52.324 -71.474 51.42 -69.9731 51.2164C-68.4323 51.1791 -66.8987 50.8396 -65.1685 50.4566C-64.2524 50.2538 -63.2812 50.0388 -62.2246 49.85C-62.2016 49.4604 -62.179 49.0531 -62.1556 48.6303C-62.0087 45.9778 -61.8281 42.7192 -61.297 39.4521C-57.8853 24.5139 -48.4622 14.3823 -34.6889 8.62577C-13.2126 -0.382457 8.93439 -1.15373 31.4424 3.25398C69.8257 10.8149 103.741 28.6236 134.729 52.1623C170.038 78.8977 198.426 111.932 220.801 149.827C227.19 160.519 231.941 171.723 232.95 184.196C233.931 195.491 230.382 204.773 220.868 211.134C210.423 217.99 198.449 220.165 186.166 219.283C182.24 218.958 178.39 218.383 174.525 217.804C171.878 217.408 169.223 217.011 166.531 216.693C165.347 216.485 163.703 216.761 163.008 217.249C152.602 225.754 140.186 229.12 127.011 230.382C110.779 231.953 95.8122 227.363 81.2769 221.112C67.9314 215.304 54.8216 209.49 41.7003 203.204C23.326 194.216 6.07878 183.079 -9.80003 170.022C-10.4685 169.385 -10.9958 168.6 -11.5394 167.791L-11.5395 167.791L-11.5397 167.791L-11.5398 167.791L-11.5404 167.79C-11.9778 167.138 -12.4258 166.472 -12.9663 165.854C-14.0524 164.819 -15.1947 163.904 -16.3369 162.988C-17.4791 162.072 -18.6213 161.157 -19.7074 160.122C-19.8049 160.029 -19.9052 159.821 -20.0383 159.544C-20.2346 159.137 -20.5021 158.581 -20.937 158.029ZM219.114 187.361C219.014 187.363 218.957 187.365 218.905 187.348C218.835 187.325 218.776 187.269 218.637 187.136C218.559 186.368 218.511 185.585 218.462 184.798C218.317 182.45 218.17 180.07 217.237 177.974C213.238 168.638 208.774 159.55 204.074 150.467C201.592 145.34 198.414 140.7 195.237 136.061C192.788 132.641 190.263 129.469 187.704 126.254L187.703 126.253L187.703 126.252C185.926 124.02 184.133 121.767 182.336 119.395C170.878 103.873 157.804 89.805 143.351 77.1852C121.191 57.9133 97.9039 40.791 70.7415 29.1858C49.0565 19.8063 26.7157 12.5649 2.88482 11.9621C-10.094 11.5684 -22.7972 12.8188 -34.9322 18.0641C-46.366 23.0566 -51.3171 32.8444 -49.6068 45.0649C-49.0613 48.1171 -47.1703 48.3072 -45.2793 48.4973C-43.8624 48.581 -42.4498 48.4879 -41.0373 48.3948C-39.6247 48.3016 -38.2121 48.2085 -36.7953 48.2922L-36.1415 48.3307C-30.6749 48.6527 -25.0068 48.9866 -19.546 49.7616C-15.2869 50.366 -11.0222 51.2061 -6.75745 52.0462L-6.75726 52.0462C-2.91434 52.8675 0.978635 53.3361 4.86824 53.8043C12.0145 54.6644 19.1493 55.5232 25.9415 58.5656C29.8019 60.3267 33.8556 61.7298 37.901 63.1301C42.6005 64.7569 47.2888 66.3797 51.6499 68.5553C60.2365 72.5921 68.6045 77.3417 76.5126 82.574C80.5438 85.123 84.3571 88.2572 88.1828 91.4016C89.8113 92.7401 91.442 94.0805 93.0927 95.3783C93.814 95.9503 94.3613 96.6445 94.9087 97.3387C95.456 98.0329 96.0034 98.727 96.7246 99.2991C97.5532 99.8898 98.4675 100.391 99.394 100.898C100.614 101.566 101.855 102.246 102.949 103.157C114.523 113.725 125.861 124.297 137.2 134.87C146.366 143.373 155.072 152.359 161.467 163.288C168.104 174.446 173.332 185.874 171.536 199.358C171.122 201.726 170.707 204.094 170.063 206.704C181.69 209.724 193.289 211.566 205.016 208.924C210.178 207.856 214.121 205.167 216.605 200.627C219.084 195.85 219.424 190.419 219.299 185.234C219.296 185.136 219.255 185.08 219.206 185.014C219.169 184.965 219.129 184.911 219.097 184.83C219.083 184.735 219.066 184.636 219.046 184.533C219.049 184.663 219.07 184.758 219.097 184.83C219.224 185.648 219.18 186.215 219.143 186.698C219.126 186.932 219.109 187.147 219.114 187.361ZM151.623 212.767L151.624 212.767C151.876 212.915 152.172 213.087 152.536 213.259C148.439 217.559 143.443 218.978 138.396 220.412L138.382 220.416C138.051 220.51 137.72 220.604 137.389 220.699C124.013 223.381 110.994 221.337 98.3725 216.219C77.1816 207.771 55.9736 198.615 36.1169 186.834C16.2545 174.816 -2.22802 161.351 -17.968 144.282C-27.6509 133.741 -37.0275 122.879 -46.3447 112.085L-46.345 112.085L-46.3635 112.064L-46.4 112.021C-48.4829 109.608 -50.563 107.199 -52.6428 104.797C-61.3775 94.633 -65.9215 82.2452 -69.2929 69.5933C-69.803 67.4652 -69.7187 65.3228 -69.6243 62.9231L-69.6243 62.9225L-69.6243 62.9218C-69.5731 61.6206 -69.5189 60.2438 -69.555 58.7526C-68.6998 59.0149 -67.9199 59.279 -67.1401 59.5431C-65.9704 59.9393 -64.8006 60.3354 -63.3764 60.7254C-59.6635 58.3313 -56.5686 61.1631 -53.5587 63.9173C-53.1806 64.2632 -52.8039 64.608 -52.4274 64.941C-50.2494 67.2464 -48.3014 69.7932 -46.5834 72.5813C-41.1822 81.4113 -33.4756 88.0633 -25.0734 94.2269C-20.6337 97.4208 -16.4241 100.856 -12.2144 104.291L-12.2141 104.292L-12.2139 104.292L-12.2137 104.292L-12.2134 104.292C-8.00415 107.727 -3.79484 111.162 0.644426 114.356C12.3343 122.809 24.3542 131.143 36.3256 139.443L36.3266 139.444L36.3267 139.444L36.3269 139.444L36.327 139.444L36.3271 139.444C41.8056 143.242 47.274 147.034 52.6959 150.826C71.6436 164.045 90.5971 177.498 109.551 190.952L109.552 190.953C122.264 199.842 135.656 207.536 150.628 212.362C150.919 212.355 151.215 212.528 151.623 212.767ZM-41.7066 59.7292C-41.3982 60.2399 -41.1373 60.7052 -40.9022 61.1247C-40.3882 62.0417 -39.997 62.7396 -39.5002 63.2129L-39.4996 63.2135C-35.4023 66.8871 -31.3049 70.5607 -26.9833 73.7573C-22.3544 77.468 -17.7398 81.2092 -13.1211 84.9537C0.495012 95.9928 14.1469 107.061 28.3084 117.459C49.2364 132.845 70.4051 147.719 91.6426 162.642L91.6435 162.642L91.6443 162.643C99.3974 168.091 107.16 173.545 114.923 179.033L114.923 179.033C126.917 187.467 138.911 195.902 152.717 201.228C154.142 201.665 155.567 202.102 157.947 202.988C157.849 201.673 157.789 200.395 157.731 199.153C157.581 195.947 157.442 192.986 156.696 190.284C153.331 177.868 147.637 166.687 138.919 157.23L138.919 157.23C132.868 150.773 126.817 144.317 120.536 138.103C118.723 136.26 116.795 134.538 114.866 132.816C112.938 131.094 111.01 129.372 109.197 127.53C107.259 125.683 105.283 123.875 103.316 122.074L103.315 122.073C100.383 119.39 97.4686 116.723 94.721 113.967C93.7412 112.878 92.5251 111.983 91.3301 111.103C88.9785 109.371 86.7085 107.699 86.4804 104.734C85.8632 104.487 85.2161 104.338 84.6207 104.2C83.6082 103.967 82.7453 103.768 82.4342 103.181C81.8957 102.498 81.7297 101.293 81.5713 100.142C81.515 99.7331 81.4597 99.3312 81.389 98.9621C79.2623 101.008 78.0338 99.8252 76.7067 98.5472C76.3082 98.1634 75.9007 97.771 75.4574 97.4549C72.8138 95.3966 70.4115 93.5682 67.7736 91.7456C66.6625 90.9918 65.3473 90.3463 64.0999 89.7342L64.0995 89.734C63.463 89.4216 62.8442 89.1179 62.2792 88.8129C61.5339 88.3636 60.8075 87.9138 60.0894 87.4692L60.0888 87.4688C58.271 86.3431 56.5065 85.2505 54.6239 84.2819C52.0759 82.9287 49.533 81.785 46.9901 80.6412C45.7186 80.0694 44.4472 79.4975 43.1751 78.8994C41.6819 78.2461 40.2278 77.5095 38.7806 76.7764C36.763 75.7543 34.7587 74.7391 32.6804 73.9654C30.3447 73.0691 27.9325 72.2532 25.4868 71.426C23.6955 70.8201 21.8863 70.2081 20.076 69.5541C18.3081 69.0119 16.5784 68.3881 14.8558 67.7669C12.412 66.8856 9.98229 66.0094 7.47742 65.3784C4.40057 64.6878 1.2293 64.198 -1.9123 63.7127L-1.91248 63.7127L-1.91267 63.7127L-1.91285 63.7127C-3.6127 63.4501 -5.30386 63.1889 -6.96667 62.898C-7.29684 62.7967 -7.58255 62.4413 -7.86442 62.0907C-8.191 61.6845 -8.51243 61.2847 -8.8919 61.2939C-9.84683 61.1584 -10.9032 61.2387 -11.9228 61.3162C-12.4191 61.3539 -12.9067 61.3909 -13.3696 61.4021C-16.6658 61.3641 -19.9033 61.3247 -23.1407 61.2853L-23.158 61.2851L-23.1753 61.2849C-26.4129 61.2455 -29.6506 61.2061 -32.9471 61.1681C-35.7922 60.5294 -38.1602 60.1151 -41.7066 59.7292ZM-67.5085 84.8768C-70.8535 83.0712 -75.2473 67.1427 -73.4645 62.8551C-72.5715 66.0926 -71.7234 69.2871 -70.882 72.4569L-70.8814 72.4592C-69.7749 76.6276 -68.6797 80.7531 -67.5085 84.8768ZM168.111 194.254L169.054 194.231C168.773 192.351 168.431 190.414 168.089 188.477C167.748 186.54 167.406 184.603 167.125 182.723C166.889 182.729 166.654 182.734 166.188 182.981C166.986 186.735 167.549 190.494 168.111 194.254ZM228.56 178.171L229.503 178.149C229.6 182.155 229.702 186.397 230.035 190.398L229.799 190.403C229.261 186.618 228.929 182.616 228.613 178.803C228.595 178.592 228.578 178.381 228.56 178.171Z"
          fill="#FF9E67"
        />
      </svg>

      <svg
        className="topRight"
        xmlns="http://www.w3.org/2000/svg"
        width="90"
        height="366"
        viewBox="0 0 90 366"
        fill="none"
      >
        <path
          d="M22.9189 352.59C21.5904 354.251 20.2619 355.58 19.2655 356.908C18.2691 357.905 16.9405 358.901 15.9442 359.897C14.6156 361.558 13.2871 364.879 12.6228 364.547C8.30511 364.215 3.32312 365.211 0.998198 359.897C0.333934 358.237 0.333934 356.244 0.998198 354.915C1.33033 353.919 3.65526 353.919 5.31592 353.587C7.30871 352.923 9.96577 352.923 11.6264 351.594C14.9478 349.601 18.6012 350.598 22.9189 352.59Z"
          fill="#FEDE66"
        />
        <path
          d="M80.0456 308.417C77.0564 308.085 73.4029 307.753 73.0708 303.435C72.7387 297.789 75.0636 292.807 77.7206 292.807C82.3705 292.807 89.0131 298.785 88.681 302.439C88.3489 305.096 83.699 308.417 80.0456 308.417Z"
          fill="#FEDE66"
        />
        <path
          d="M31.5544 126.741C38.5292 129.398 39.1934 134.712 38.8613 140.69C38.5292 144.344 36.5364 145.34 33.5472 143.347C31.2223 142.019 28.2331 140.69 26.9045 138.365C24.5796 134.048 25.9081 131.723 31.5544 126.741Z"
          fill="#FEDE66"
        />
        <path
          d="M27.901 247.969C28.5652 250.626 29.2295 253.283 29.8938 256.272C29.8938 257.269 29.5616 258.929 28.8974 259.261C26.9046 260.59 19.9298 256.937 17.937 254.279C15.6121 249.962 15.9442 247.305 19.2655 244.648C21.9226 242.655 24.2475 244.316 26.2403 244.98C27.2367 245.312 28.2331 246.64 29.2295 247.305C28.8974 247.305 28.5652 247.637 27.901 247.969Z"
          fill="#FEDE66"
        />
        <path
          d="M43.1791 352.591C46.8326 354.251 50.1539 355.58 53.1431 357.573C54.4716 358.237 55.1359 360.894 54.8037 362.222C54.4716 363.551 52.4788 364.547 51.1503 364.879C47.4968 365.876 40.8542 363.219 39.1935 360.23C38.5292 358.901 38.5292 356.908 39.1935 355.58C39.8578 354.583 41.8506 353.919 43.1791 352.591Z"
          fill="#FEDE66"
        />
        <path
          d="M87.0206 179.55C87.6849 180.546 88.3491 181.543 89.0134 181.875C90.3419 182.539 92.999 183.203 92.999 183.868C93.3311 186.857 93.3311 189.846 92.6669 192.835C92.6669 193.167 89.3455 193.167 87.3527 192.835C86.0242 192.835 84.6957 192.171 83.3671 191.507C79.3816 189.514 79.0494 184.532 82.7029 181.875C84.3635 180.878 85.6921 180.214 87.0206 179.55Z"
          fill="#FEDE66"
        />
        <path
          d="M16.2764 304.431C16.2764 300.114 17.937 299.117 21.5905 300.446C25.5761 301.442 28.8974 303.435 30.5581 307.421C30.8902 308.417 30.8902 310.41 30.2259 311.074C29.5617 311.738 27.5689 312.07 26.5725 311.738C23.2511 310.41 20.262 308.417 17.2728 306.756C16.6085 306.424 16.2764 305.096 16.2764 304.431Z"
          fill="#FEDE66"
        />
        <path
          d="M37.1997 33.0794C37.5318 32.4151 38.1961 30.0902 39.5246 29.4259C40.8532 28.7616 43.5102 29.758 44.5066 31.0866C46.4994 32.7472 47.8279 35.0722 48.8243 37.3971C49.1565 38.7256 48.4922 41.0505 47.4958 42.0469C46.8315 42.7112 44.5066 42.7112 43.1781 42.0469C40.521 40.7184 37.1997 39.0578 37.1997 33.0794Z"
          fill="#FEDE66"
        />
        <path
          d="M89.0127 30.7545C89.3448 30.4224 90.0091 28.0975 91.3376 27.7653C92.6662 27.4332 94.9911 28.4296 95.9875 29.426C97.9803 31.0867 99.9731 32.7473 100.969 35.0723C101.634 36.7329 100.637 39.0578 100.305 41.0506C98.6445 40.7185 96.9839 40.7185 95.6553 40.0542C92.6662 38.3936 89.0127 37.065 89.0127 30.7545Z"
          fill="#FEDE66"
        />
        <path
          d="M56.1323 134.38C56.4645 133.716 57.1287 131.723 58.4573 131.058C59.4536 130.726 61.4464 131.391 62.4428 132.055C66.0963 134.048 68.4212 136.705 67.757 141.355C67.4248 144.344 65.7642 145.34 62.775 144.344C59.1215 143.015 56.4645 139.362 56.1323 134.38Z"
          fill="#FEDE66"
        />
        <path
          d="M83.6999 239.998C86.3569 240.994 89.014 240.994 89.6783 242.323C90.6747 243.651 90.6747 246.308 90.3425 248.301C90.0104 250.294 88.3497 251.622 85.6927 249.962C84.3641 249.297 82.7035 249.297 81.3749 248.301C79.7143 246.64 78.3858 244.647 76.7251 242.987C78.7179 241.658 80.3786 239.998 82.3713 238.669C82.7035 238.669 83.6999 239.665 83.6999 239.998Z"
          fill="#FEDE66"
        />
        <path
          d="M31.2231 201.47C26.9054 201.138 22.2555 197.817 21.5913 194.496C21.2591 193.167 21.9234 190.842 22.9198 190.178C23.5841 189.514 26.2411 189.514 27.2375 190.51C29.8946 192.503 32.5516 194.828 34.2123 197.485C35.873 200.142 33.548 201.47 31.2231 201.47Z"
          fill="#FEDE66"
        />
        <path
          d="M45.8358 9.82984C40.8538 9.16558 40.8538 4.84786 40.5217 2.1908C40.1896 -0.466261 47.1644 -2.45905 50.4857 -0.46626C52.8106 0.862269 54.8034 2.52293 57.4605 4.18359C53.4749 7.50492 46.5001 2.52293 45.8358 9.82984Z"
          fill="#FEDE66"
        />
        <path
          d="M65.7634 30.0902C69.4169 30.0902 74.731 39.0578 73.0703 41.3827C72.7382 42.047 71.0775 43.3755 70.7454 43.0434C68.0883 41.7148 65.4313 40.3863 63.7706 38.3935C62.7742 37.065 62.7742 34.4079 63.1064 32.4151C63.1064 31.7509 65.0991 30.7545 65.7634 30.0902Z"
          fill="#FEDE66"
        />
        <path
          d="M66.4284 202.134C65.7641 202.467 64.1035 204.127 63.4392 203.795C60.1179 201.47 55.1359 201.802 53.8074 196.488C52.811 193.167 54.1395 192.503 56.4644 191.838C59.7858 191.506 66.7605 198.149 66.4284 202.134Z"
          fill="#FEDE66"
        />
        <path
          d="M95.3248 84.5599C91.3392 83.5635 87.0215 83.8957 86.0251 78.9137C85.693 77.5851 85.3609 75.2602 86.0251 74.596C87.3536 73.5996 89.6786 72.9353 91.3392 73.2674C94.9927 74.9281 96.3212 79.5779 95.3248 84.5599Z"
          fill="#FEDE66"
        />
        <path
          d="M66.4286 77.5849C71.0784 79.5777 72.407 83.2311 72.0748 87.5489C71.7427 90.8702 69.7499 91.8666 67.0928 90.2059C61.4466 86.5525 61.1145 81.2384 66.4286 77.5849Z"
          fill="#FEDE66"
        />
        <path
          d="M45.503 91.5344C41.8496 89.2094 35.8712 89.2094 35.5391 83.231C35.5391 81.5704 36.8676 79.9097 37.864 77.9169C47.828 86.5524 48.1601 86.8845 45.503 91.5344Z"
          fill="#FEDE66"
        />
        <path
          d="M62.7746 254.944C57.7926 254.612 53.1428 254.612 52.4785 248.301C52.4785 246.973 52.8106 245.644 53.1428 244.316C54.4713 244.648 55.7998 244.316 56.7962 244.98C60.1176 247.305 64.4353 249.298 62.7746 254.944Z"
          fill="#FEDE66"
        />
        <path
          d="M74.3992 347.941C74.3992 348.605 74.3992 349.602 74.3992 349.602C76.0598 349.934 77.7205 349.934 78.7169 350.598C80.3776 352.259 81.0418 354.584 82.0382 356.576C82.0382 356.908 81.0418 357.905 80.3776 357.905C77.7205 357.573 74.7313 357.573 72.0743 356.576C70.7457 355.912 69.7493 353.587 70.0815 351.926C70.4136 350.266 72.0743 348.937 73.0707 347.277C73.7349 347.609 74.067 347.609 74.3992 347.941Z"
          fill="#FEDE66"
        />
        <path
          d="M54.8033 295.796C57.4604 299.117 59.4532 301.774 61.7781 304.099C60.4495 305.096 59.4532 306.424 58.1246 306.756C55.1354 307.089 49.8213 302.771 50.4856 300.446C50.4856 299.117 52.4784 298.121 54.8033 295.796Z"
          fill="#FEDE66"
        />
        <path
          d="M77.3882 5.18018C72.4062 5.51231 69.417 4.51591 69.417 0.530324C69.417 -0.466074 71.7419 -2.12674 73.0704 -2.12674C76.3918 -2.45887 79.381 -1.46247 79.7131 2.52312C79.7131 3.51951 77.7203 4.84804 77.3882 5.18018Z"
          fill="#FEDE66"
        />
      </svg>
    </div>
  );
};
